import { ComponentPropsWithoutRef, ComponentType, FC } from 'react';
import styled, { css } from 'styled-components';
import { TShapeType } from 'interfaces';

type TIconProps = ComponentPropsWithoutRef<'span'> & {
  svg: ComponentType;
  shape?: TShapeType;
  clickable?: boolean;
};

const SHAPE_STYLES = {
  round: css`
    border-radius: 8px;
  `,
  circle: css`
    border-radius: 50%;
  `
};

export const Icon: FC<TIconProps> = ({
  svg,
  shape = 'round',
  clickable = true,
  onClick,
  ...props
}) => {
  const StyledSvg = styled(svg)`
    padding: 6px;
    font-size: 20px;
    height: fit-content;
    width: fit-content;
    cursor: default;
    ${clickable &&
    css`
      &:hover {
        cursor: pointer;
        background: var(--v3-black-1);
      }
    `}
    ${SHAPE_STYLES[shape]}
  `;

  return <StyledSvg {...props} {...(clickable && { onClick })} />;
};
